import { Routes } from '@angular/router';
// Third party packages
// Custom packages - Misc
import { RoleGuard } from 'src/app/shared/guards/role.guard';
// Custom packages - Component
import { WaterMetersListComponent } from 'src/app/modules/water-meters/pages/water-meters-list/water-meters-list.page';
var ɵ0 = {
    permissions: ['canReadPropertiesList']
};
var routes = [
    {
        path: 'list',
        component: WaterMetersListComponent,
        canActivate: [RoleGuard],
        data: ɵ0,
    },
    {
        path: '**',
        redirectTo: 'it/errors/404'
    }
];
var WaterMetersRoutingModule = /** @class */ (function () {
    function WaterMetersRoutingModule() {
    }
    return WaterMetersRoutingModule;
}());
export { WaterMetersRoutingModule };
export { ɵ0 };
